/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Formik, Field } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  Autocomplete
} from '@mui/material';
import { Close, ExpandMore } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { ValidateCurrencyAdd } from '../../assets/validation';
import CurrencyAction from '../../store/actions/CurrencyAction';

function CurrencyAdd({ openmodal, onCloseModal }) {
  const [data, setData] = React.useState([]);

  const [curData, setCurData] = React.useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(CurrencyAction.getCurrencyList());
  }, [dispatch]);
  const { currenciesAllItem } = useSelector((state) => state.currency);

  useEffect(() => {
    if (currenciesAllItem) {
      if (currenciesAllItem.data) {
        setData(currenciesAllItem.data);
      } else {
        setData([]);
      }
    }
  }, [currenciesAllItem]);

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Formik
          initialValues={{
            name: curData && curData.currency ? curData.currency : null,
            symbol: curData && curData.symbol ? curData.symbol : '',
            short_name: curData && curData.code ? curData.code : ''
          }}
          enableReinitialize
          validationSchema={ValidateCurrencyAdd}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            // console.log(values, "values");
            dispatch(CurrencyAction.add(values, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            // handleBlur,
            // setFieldValue,
            handleSubmit,
            handleReset,
            isSubmitting
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Add Currency"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <Field
                    name="name"
                    component={Autocomplete}
                    className="CurrencyField"
                    options={data}
                    value={curData}
                    // disableClearable
                    onChange={(e, newvalue) => {
                      console.log('🚀 ~ CurrencyAdd ~ newvalue:', newvalue);
                      handleChange(e);
                      setCurData(newvalue);
                    }}
                    getOptionLabel={(option) => option.currency}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option.currency}>
                          {option.currency}
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="name"
                        error={touched.name && !!errors.name}
                        helperText={touched.name && errors.name}
                        label="Select Currency"
                        placeholder="Search Currency"
                        variant="outlined"
                        margin="normal"
                        required={false}
                        InputLabelProps={{ required: true }}
                        SelectProps={{
                          IconComponent: ExpandMore
                        }}
                      />
                    )}
                  />

                  <TextField
                    id="symbol"
                    fullWidth
                    label="Currency Symobol"
                    disabled
                    name="symbol"
                    margin="normal"
                    value={values.symbol}
                    required={false}
                  />
                  <TextField
                    id="short_name"
                    fullWidth
                    label="Currency Short Name"
                    disabled
                    name="short_name"
                    margin="normal"
                    value={values.short_name}
                    required={false}
                  />
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                      setCurData(null);
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

CurrencyAdd.propTypes = {
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default CurrencyAdd;
